import React from 'react';
const principles = ["Moins d'improvisation.", 'Plus de structure.', "Plus d'énergie.", 'Plus de résultats.'];
export function ExpertSection() {
  return <section className="w-full bg-bg-main py-20 px-4 border-t border-border-light/50" data-id="element-115">
      <div className="max-w-3xl mx-auto text-center" data-id="element-116">
        <div className="w-28 h-28 bg-primary/15 border border-primary/40 rounded-full mx-auto flex items-center justify-center text-5xl mb-8 relative" data-id="element-117">
          🏋️‍♂️
        </div>

        <p className="text-primary font-display font-bold uppercase tracking-[0.2em] text-xs sm:text-sm mb-3" data-id="element-118">
          À Propos de Functional Clé en Main
        </p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-white mb-8 tracking-tight uppercase" data-id="element-119">
          L'équipe derrière Functional Clé en Main
        </h2>

        <div className="relative bg-bg-alt border border-border-light rounded-sm p-8 sm:p-10" data-id="element-120">
          <span className="absolute -top-5 left-6 font-display text-7xl text-primary leading-none" data-id="element-121">
            "
          </span>
          <p className="text-white text-lg sm:text-xl leading-relaxed italic font-medium relative z-10" data-id="element-122">
            Nous avons condensé dans ce système les frameworks utilisés par les
            coachs functional modernes pour créer des classes premium, des
            expériences engageantes et des programmations professionnelles.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-8" data-id="element-123">
          {principles.map((p, i) => <div key={i} className="bg-bg-alt border border-primary/30 rounded-sm py-4 px-3 text-center hover:border-primary/60 transition-colors" data-id="element-124">
              <p className="font-display text-primary font-bold text-sm sm:text-base uppercase tracking-wide" data-id="element-125">
                {p}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}